/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, InputLabel, MenuItem, Select } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";

const PermitListAuthEditor = (props) => {
    
    const { showCheckbox } = props;
    const { t } = useTranslation();
    const { component, update } = useUpdateComponent();
    const {
        show_summary = false,
        selected_type = "housing"
    } = component;
    const permitTypeOptions = ["housing"];

    const handlePermitTypeChange = (event) => {
        update("selected_type", event.target.value);
    };

    const handleCheckBoxChange = (event) => {
        update("show_summary", event.target.checked);
    };

    return (
        <div className='simplicity-editor-frame permit-list-auth-edit'>
            <div className='permit-type-label'>
                <InputLabel id='permit-type-select-label'>{t("commons.type")}</InputLabel>
                <Select
                    className='permit-type-select'
                    id='permit-type-select'
                    labelId='permit-type-select-label'
                    onChange={handlePermitTypeChange}
                    value={selected_type}
                    variant='standard'
                >
                    {permitTypeOptions.map((option, index) => (
                        <MenuItem className='permit-type-option' key={index} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            {showCheckbox && (
                <FormControlLabel
                    label={t("commons.displayTextSummaryAboveTable")}
                    control={
                        <Checkbox
                            checked={show_summary}
                            onChange={handleCheckBoxChange}
                        />
                    }
                />
            )}
        </div>
    );
};

PermitListAuthEditor.displayName = "PermitListAuthEditor";
export { PermitListAuthEditor };
